import bee from "./Bee"
export default {
    name: "Login",
    get_logged_in_user(){
        var user = null;
        var user_str = localStorage.getItem("user");
        if(user_str){
            user = JSON.parse(user_str);
        }
        return user;
    },
    /*
        var query = {
            email: "",
            password: ""
        }
    */
    /* eslint-disable no-unused-vars */
    login(query,success,fail){
        var token = bee.token;
        bee.token = null;
        bee.post({
            _f_login: {
                email: query.email,
                password: query.password
            }
        }).then(res => {
            // console.log("res of login: ", res);
            bee.token = res._f_login.token;
            localStorage.setItem("token", bee.token);
            localStorage.setItem("user", JSON.stringify(res._f_login.user));
            if(success){
                success(res._f_login);
            }
        }).catch(errs => {
            // console.log("errors of login: ", errs);
            bee.token = token;
            if(fail){
                fail(errs);
            }
        });
    },
    /* eslint-disable no-unused-vars */
    logout(success){
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("before_singup_route");
        success(true);
    }
}